// The calendar view the Prices page draws, published by the page itself so the rail marks what is on screen.

import { useSyncExternalStore } from "react";
import type { CalendarViewKey } from "./calendarViews";

let shown: CalendarViewKey | null = null;
const listeners = new Set<() => void>();

/** Null while no calendar is on screen. */
export function publishShownCalendarView(view: CalendarViewKey | null): void {
    if (view === shown) return;
    shown = view;
    for (const listener of [...listeners]) listener();
}

export function getShownCalendarView(): CalendarViewKey | null {
    return shown;
}

export function subscribeShownCalendarView(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useShownCalendarView(): CalendarViewKey | null {
    return useSyncExternalStore(subscribeShownCalendarView, getShownCalendarView, getShownCalendarView);
}
